import * as React from 'react'
export const SidebarClosedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 15 15"
    width="15"
    height="15"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.3 3.1h2c.22 0 .4.18.4.4v8a.4.4 0 0 1-.4.4h-2V3.1Zm-.8 0H2.7a.4.4 0 0 0-.4.4v8c0 .221.18.4.4.4h6.8V3.1Zm-8 .4a1.2 1.2 0 0 1 1.2-1.2h9.6a1.2 1.2 0 0 1 1.2 1.2v8a1.2 1.2 0 0 1-1.2 1.2H2.7a1.2 1.2 0 0 1-1.2-1.2v-8Z"
      clipRule="evenodd"
    />
  </svg>
)
